// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"331624e5","239":"2c95a41b","455":"73cad91b"}[chunkId] + ".chunk.js";
};